<template>
    <div class="task-carousel">
        <div>
            <ul class="task-carousel-pager pager">
                <li class="previous" :class="isFirstPage ? 'disabled' : ''"><a href="#" @click="gotoStartPage"><span aria-hidden="true" class="glyphicon glyphicon-backward"></span></a></li>
                <li class="previous" :class="isFirstPage ? 'disabled' : ''"><a href="#" @click="prevPage"><span aria-hidden="true" class="glyphicon glyphicon-step-backward"></span></a></li>
                <li class="next"><a href="#" @click="nextPage"><span aria-hidden="true" class="glyphicon glyphicon-step-forward"></span></a></li>
            </ul>
        </div>
        <div class="row">
            <div class="task-carousel-column" v-for="d in daysVisible" :class="isZoomedDay(getDateFromOffset(d - 1)) ? 'col-lg-6' : 'col-lg-1'">
                <h4 class="text-center user-action" @click="updateZoomedDay(getDateFromOffset(d - 1))">
                    {{getDateFromOffset(d - 1)| formatDate('dddd')}}
                    <br>
                    <small class="text-center">{{getDateFromOffset(d - 1)| formatDate('MMM Do \'YY')}}</small>
                </h4>
                <ul class="list-group" v-if="isDataLoaded">
                    <li class="list-group-item" :class="t.length ? 'grouped-items' : ''" v-for="t in tasks[getDateFromOffset(d - 1, 'YYYY-MM-DD')]">
                        <carousel-item :item="t" :collapsed="!isZoomedDay(getDateFromOffset(d - 1))" v-if="!t.length"></carousel-item>
                        <div v-else>
                            <div class="user-action" @click="toggleGroup(t)">
                                <span class="glyphicon" :class="{'glyphicon-expand': !t[2], 'glyphicon-collapse-down': t[2] }"></span>
                                {{t[1].length}} tasks from {{t[0]}}
                            </div>
                            <ul class="list-group" v-if="t[2]">
                                <li class="list-group-item" v-for="ts in t[1]">
                                    <carousel-item :item="ts" :collapsed="!isZoomedDay(getDateFromOffset(d - 1))"></carousel-item>
                                </li>
                            </ul>
                        </div>
                        <span class="clearfix"></span>
                    </li>
                    <li v-if="!tasks[getDateFromOffset(d - 1, 'YYYY-MM-DD')] || !tasks[getDateFromOffset(d - 1, 'YYYY-MM-DD')].length" class="list-group-item text-center">
                        0 items
                    </li>
                </ul>
            </div>
        </div>
        <div class="loader text-center" v-if="!isDataLoaded">
            <div class="well well-sm">Loading...</div>
        </div>
        <div class="error-message text-center" v-if="errorMsg.length">
            <div class="well well-sm bg-danger">{{errorMsg}}</div>
        </div>
    </div>
</template>

<script>
    import axios from '@/api/client'
    import CarouselItem from '@/components/taskcarousel/CarouselItem'

    export default {
        props: {
            api: {
                type: String,
                required: true
            },
            userId: {
                type: Number,
                required: true
            },
            firstDate: {
                type: [Date, String],
                default: function () {
                    const d = new Date()
                    d.setHours(0, 0, 0, 0)
                    return d
                }
            },
            daysVisible: {
                type: Number,
                default: 7,
                validator: function (v) {
                    return v > 0 && v <= 12
                }
            },
            preZoomedDate: {
                type: [Date, String],
                default: function () {
                    const d = new Date()
                    d.setHours(0, 0, 0, 0)
                    return d
                }
            },
            initialTasks: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            maxBeforeGroup: {
                type: Number,
                default: 1
            }
        },
        name: 'TaskCarousel',
        data () {
            return {
                currentPage: 0,
                zoomedDate: null,
                tasks: {},
                errorMsg: ''
            }
        },
        computed: {
            isDataLoaded: function () {
                return this.tasks.hasOwnProperty(this.getDateFromOffset(0, 'YYYY-MM-DD')) || this.errorMsg.length
            },
            startingDate: function () {
                const startingDate = new Date(this.firstDate)
                startingDate.setHours(0, 0, 0, 0)

                if (startingDate.getDay() > 0) {
                    startingDate.setDate(startingDate.getDate() - startingDate.getDay())
                }

                return startingDate
            },
            isFirstPage: function () {
                return this.currentPage === 0
            },
            firstVisibleDate: function () {
                return this.getDateFromOffset(0)
            },
            lastVisibleDate: function () {
                return this.getDateFromOffset(this.daysVisible)
            }
        },
        methods: {
            getDateFromOffset: function (o, format) {
                const d = new Date(this.startingDate)
                d.setDate(d.getDate() + o + (this.currentPage * this.daysVisible))

                if (typeof format === 'undefined') {
                    return d
                } else {
                    return this.$options.filters.formatDate(d, format)
                }
            },
            prevPage: function () {
                if (this.currentPage < 1) {
                    return
                }
                this.currentPage--

                this.zoomedDate.setDate(this.zoomedDate.getDate() - this.daysVisible)
            },
            nextPage: function () {
                this.currentPage++

                this.zoomedDate.setDate(this.zoomedDate.getDate() + this.daysVisible)

                return this.fetchTasks()
            },
            gotoStartPage: function () {
                this.zoomedDate.setDate(this.zoomedDate.getDate() - (this.daysVisible * this.currentPage))

                this.currentPage = 0
            },
            isZoomedDay: function (d) {
                return this.zoomedDate.toString() === d.toString()
            },
            updateZoomedDay: function (d) {
                this.zoomedDate = d
            },
            toggleGroup: function (g) {
                this.$set(g, 2, !g[2])
            },
            fetchTasks: async function () {
                if (!this.tasks.hasOwnProperty(this.$options.filters.formatDate(this.firstVisibleDate, 'YYYY-MM-DD'))) {
                    var self = this

                    const response = await axios.get(this.api, {
                        params: {
                            userId: this.userId,
                            start: this.firstVisibleDate.toISOString(),
                            end: this.lastVisibleDate.toISOString()
                        }
                    })
                    .catch(function (error) {
                        self.errorMsg = 'Unable to load tasks - '

                        if (error.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx

                            self.errorMsg += error.response.status
                        } else {
                            // Something happened in setting up the request that triggered an Error
                            self.errorMsg += error.message
                        }
                    })

                    if (response && response.data) {
                        if (response.data.result === true) {
                            this.tasksToDays(response.data.tasks)
                        } else {
                            if (response.data.errorMessage) {
                                self.errorMsg = response.data.errorMessage
                            }
                        }
                    }
                }
            },
            tasksToDays: function (tasks) {
                for (let i = 0; i < this.daysVisible; i++) {
                    let day = this.getDateFromOffset(i, 'YYYY-MM-DD')

                    if (tasks.hasOwnProperty(day)) {
                        tasks[day] = this.groupTasks(tasks[day])
                    }

                    this.$set(this.tasks, day, tasks.hasOwnProperty(day) ? tasks[day] : [])
                }
            },
            groupTasks: function (tasks) {
                const bySource = {}
                const self = this
                tasks.forEach(function (i, k) {
                    if (!bySource.hasOwnProperty(i.source)) {
                        bySource[i.source] = []
                    }
                    bySource[i.source].push(i)
                })

                let finalList = []

                if (bySource.hasOwnProperty('')) {
                    finalList = finalList.concat(bySource[''])

                    delete bySource['']
                }

                Object.keys(bySource).forEach(function (k) {
                    const i = bySource[k]

                    if (i.length <= self.maxBeforeGroup) {
                        finalList = finalList.concat(i)
                        delete bySource[k]
                    }
                })

                Object.keys(bySource).forEach(function (k) {
                    const i = bySource[k]

                    finalList.push([k, i, false])
                })

                return finalList
            }
        },
        created () {
            this.zoomedDate = this.preZoomedDate

            if (Object.keys(this.initialTasks).length > 0) {
                this.tasksToDays(this.initialTasks)
            }

            if (this.zoomedDate < this.startingDate) {
                this.zoomedDate = new Date()
                this.zoomedDate.setHours(0, 0, 0, 0)
            }

            if (!Object.keys(this.tasks).length && this.api) {
                return this.fetchTasks()
            }
        },
        components: { CarouselItem }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// TaskCarousel.vue?547aa4a6